import * as dayjs from "dayjs";

export function getYearsModified(mod) {
    let date = dayjs().add(mod, 'year')
    if (mod < 0) date = date.startOf('year')
    else date = date.endOf('year')
    return date.format('YYYY-MM-DD');
}